// Nothing secret reaches a log line, a live terminal or chat (05 §6.4). Known
// values are replaced by name; anything token-shaped is replaced by shape.

const PATTERNS: Array<[RegExp, string]> = [
  [/\bgh[pousr]_[A-Za-z0-9]{20,}\b/g, '[token:github]'],
  [/\bgithub_pat_[A-Za-z0-9_]{20,}\b/g, '[token:github]'],
  [/\blin_(?:api|oauth|wh)_[A-Za-z0-9]{16,}\b/g, '[token:linear]'],
  [/\bsk-ant-[A-Za-z0-9_-]{16,}\b/g, '[token:anthropic]'],
  [/\bsk-[A-Za-z0-9_-]{20,}\b/g, '[token:sk]'],
  [/\beyJ[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}\.[A-Za-z0-9_-]{8,}\b/g, '[token:jwt]'],
  [/\b(AKIA|ASIA)[A-Z0-9]{16}\b/g, '[token:aws]'],
  [/-----BEGIN [A-Z ]*PRIVATE KEY-----[\s\S]*?-----END [A-Z ]*PRIVATE KEY-----/g, '[token:private-key]'],
  [/\b(authorization|cookie|x-automations-secret)\s*[:=]\s*\S+/gi, '$1: [redacted]'],
]

/** Values shorter than this are not redacted by value: "1" would eat every digit. */
const MIN_SECRET_LENGTH = 6

export class Redactor {
  private secrets: Array<[string, string]> = []

  /** Register the actual secret values loaded for this container or request. */
  addSecrets(named: Record<string, string | undefined>): void {
    for (const [name, value] of Object.entries(named)) {
      if (value && value.length >= MIN_SECRET_LENGTH) this.secrets.push([value, `[secret:${name}]`])
    }
    // Longest first, so a secret containing another is replaced whole.
    this.secrets.sort((a, b) => b[0].length - a[0].length)
  }

  redact(text: string): string {
    let out = text
    for (const [value, label] of this.secrets) out = out.split(value).join(label)
    for (const [re, label] of PATTERNS) out = out.replace(re, label)
    return out
  }
}

export const defaultRedactor = new Redactor()
